interface LoginAPI extends Window {
  LoginAPI: any;
}

declare const window: LoginAPI;

export default async function getCustomers(): Promise<{ state: 'clientNotInited' | 'noToken' | 'customerData'; data: unknown }> {
  if (!window.LoginAPI.isModuleInited()) {
    // Do nothing, wait for the login_api_init event
    return new Promise(resolve => {
      resolve({ state: 'clientNotInited', data: null });
    });
  }

  if (!(await window.LoginAPI.getToken())) {
    // No token, logged out status
    return new Promise(resolve => {
      resolve({ state: 'noToken', data: null });
    });
  }

  const customerResponse = await window.LoginAPI.getCustomers();

  return new Promise(resolve => {
    resolve({ state: 'customerData', data: customerResponse?.data || null });
  });
}
